<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">广播测试</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="formdata"
          :label-width="labelWidth"
        >
          <el-form-item label="文字广播" prop="Text">
            <el-input
              type="textarea"
              v-model="formdata.Text"
              placeholder="请输入要广播的文字"
            ></el-input>
          </el-form-item>
          <el-form-item label="语速" prop="Speed">
            <el-input-number
              :min="1"
              :max="10"
              v-model="formdata.Speed"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="循环次数" prop="Times">
            <el-input-number
              :min="1"
              :max="100"
              v-model="formdata.Times"
            ></el-input-number>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="startTTS">文 字 广 播</el-button>
            <el-button @click="stopTTS">停 止 广 播</el-button>
          </el-form-item>
          <el-row>
            <el-col> </el-col>
          </el-row>
          <el-form-item label="MP3">
            <el-input type="file" v-model="formdata.file"></el-input>
          </el-form-item>
          <el-form-item label="MP3播放方式">
            <el-select v-model="formdata.PlayMode" placeholder="请选择">
              <el-option key="0" label="顺序播放" value="0"></el-option>
              <el-option key="1" label="循环播放" value="1"></el-option>
              <el-option key="2" label="随机播放" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="播放音量" prop="PlayVolume">
            <div class="volume_block">
              <el-slider v-model="formdata.PlayVolume"></el-slider>
            </div>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column prop="Name" label="Name"></el-table-column>
              <el-table-column prop="Address" label="Address"></el-table-column>
              <el-table-column prop="Id" label="Id"></el-table-column>
              <el-table-column prop="MacAddr" label="MacAddr"></el-table-column>
              <el-table-column prop="Online" label="Online">
                <template slot-scope="scope">
                  <span v-if="scope.row.Online == 0" style="color: red"
                    >离线</span
                  >
                  <span v-else-if="scope.row.Online == 1" style="color: green"
                    >在线</span
                  >
                </template>
              </el-table-column>
              <el-table-column prop="TaskId" label="TaskId"></el-table-column>
              <el-table-column
                prop="TaskName"
                label="TaskName"
              ></el-table-column>
              <el-table-column
                prop="TaskPriority"
                label="TaskPriority"
              ></el-table-column>
              <el-table-column
                prop="TaskUser"
                label="TaskUser"
              ></el-table-column>
              <el-table-column prop="Type" label="Type"></el-table-column>
              <el-table-column prop="Version" label="Version"></el-table-column>
              <el-table-column prop="Volume" label="Volume"></el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >
                    <el-button
                      @click="editDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                    <el-button
                      @click="deleteClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import ZJApp from "../../../../app";
const ZJPlayer = ZJApp.ZJPlayer;
console.log(ZJPlayer);
const MediaCenter = ZJPlayer.MediaCenter;
const MSG = ZJPlayer.MediaCenterMsg;

export default {
  name: "ZjDemoBroadcast",
  controller: "UI",
  action: "broadcast",
  data() {
    return {
      formdata: {
        Text: "",
        Speed: 1,
        Times: 1,
        file: null,
        PlayMode: 0,
        PlayVolume: 0,
      },
      tableData: [],
      loading: false,
      loadingText: "",
      multipleSelection: [],
      TASK_NAME_MIC0 :"单向广播",
      TASK_NAME_TEXT : "文字广播",
      TASK_NAME_MP3 : "音乐广播",
      tempTaskId:null
    };
  },
  created() {
    console.log("mediaCenter.extend.broadcast",this.CNF('mediaCenter.extend.broadcast'));
    this.mc = new MediaCenter({
      address:this.CNF('mediaCenter.extend.broadcast')
    });
    this.mc.on("connected", () => this.onConnected());
    this.mc.on("msg", (e) => this.onRecv(e));
    this.mc.on("error", (e) => this.onError(e));
    this.handleLoad();
  },
  methods: {
    // 加载设备
    handleLoad() {
      this.tableData = [];
      this.loading = true;
      this.loadingText = "加载广播设备中...";
      if (this.mc.$connected) {
        this.beginGetEndpoints();
      } else {
        this.mc.connect().then(() => this.beginGetEndpoints());
      }
    },

    // 成功连接到媒体中心
    onConnected() {
      //this.beginGetRegions();
    },

    beginGetEndpoints() {
      // 发送命令：获取终端设备数据
      this.mc.sendCmd(MSG.Get_End_Points);
    },

    onError(e) {
      console.error(e);
      let msg = e && e.error && e.error.message ? e.error.message : e;
      this.$message.error("出错了: " + msg);
      this.loading = false;
    },

    // 接收到媒体中心的响应
    onRecv(e) {
      console.log(e);
      const msg = e.data;
      if (msg.isResponse()) {
        console.log(msg);
        switch (msg.msgCode) {
          case MSG.Get_End_Points:
            this.onGetEndpoints(msg.getJsonData());
            break;
          case MSG.Start_TTS:
            var r = msg.getJsonData();
            if (r && r.code == "0" && r.data) {
              this.tempTaskId = r.data;
              this.$message.success("文字广播成功");
            } else {
              this.$message.error("文字广播失败");
            }
            break;
          case MSG.Broadcast_Callback:
            // eslint-disable-next-line no-redeclare
            var r = msg.getJsonData();
            this.$message.success(JSON.stringify(r));
            break;
        }
      }
    },

    // 处理获取设备的响应
    onGetEndpoints(r) {
      if (r && r.code == "0" && r.data) {
        const list = r.data;
        console.log(list);
        for (let i = 0; i < list.length; i++) {
          this.tableData.push(list[i]);
        }

        if (this.tableData.length >= list.length) {
          this.loadingText = "加载广播设备...100%";
        }
      } else {
        this.loading = false;
        console.error(r && r.msg ? r.msg : "未获取到设备信息");
        this.$message.error(r && r.msg ? r.msg : "出错了: 无设备信息");
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    startTTS() {
      if (
        this.multipleSelection == null ||
        this.multipleSelection.length <= 0
      ) {
        this.$message.warning("请选择广播设备");
        return;
      }

      let params = {
        taskName: this.TASK_NAME_TEXT,
        text: this.formdata.Text,
        sexVoice: 1,
        voiceSpeed: this.formdata.Speed,
        playTimes: this.formdata.Times,
        volume: this.formdata.PlayVolume,
        endpoints: this.multipleSelection.map((item) => {
          return item.Id;
        }),
      };
      this.sendCmd(MSG.Start_TTS, params);
    },
    stopTTS() {
      if (
        this.multipleSelection == null ||
        this.multipleSelection.length <= 0
      ) {
        this.$message.warning("请选择广播设备");
        return;
      }

      let params = {
        taskId: this.tempTaskId //"{4F71C3E34B3C43E88EF4A2BC0A3CF4E4}" // 
      };
      this.sendCmd(MSG.Stop_TTS, params);
    },
    sendCmd(cmd, params) {
      if (this.mc.$connected) {
        this.mc.sendCmd(cmd, params);
      } else {
        this.mc.connect().then(() => {
          this.mc.sendCmd(cmd, params);
        });
      }
    },
  },
};
</script>
<style scoped>
.el-slider {
  width: 100%;
}

.volume_block {
  width: 250px;
}
</style>
